export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}
export async function api<T>(path: string, body?: unknown): Promise<T> {
  let response: Response;
  try {
    response = await fetch("/api/v1/course-quiz" + path, {
      method: body === undefined ? "GET" : "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(0, "网络连接失败，请重试；已提交的进度不会丢失。");
  }
  const data = await response
    .json()
    .catch(() => ({ detail: "接口响应格式错误，请检查本地联调服务" }));
  if (!response.ok)
    throw new ApiError(
      response.status,
      typeof data.detail === "string"
        ? data.detail
        : (data.message ?? "接口请求失败"),
    );
  return data as T;
}
export type Item = { id: string; text: string };
export type Answer = {
  selectedItemIds?: string[];
  pairs?: { leftId: string; rightId: string }[];
  orderedItemIds?: string[];
  grades?: Record<string, string>;
  answers?: { questionId: string; optionIds: string[] }[];
};
export type Question = {
  id: string;
  type:
    "select-many" | "match-pairs" | "order-tap" | "grade-map" | "matrix-select";
  stem: { title: string; description?: string; instruction?: string };
  content: {
    selectionMode?: string;
    layout?: string;
    rowLabel?: string;
    items?: Item[];
    leftItems?: Item[];
    rightItems?: Item[];
    rows?: Item[];
    columns?: Item[];
    grades?: string[];
    options?: Item[];
    questions?: (Item & {
      rowId?: string;
      columnId?: string;
      selectionMode?: string;
    })[];
  };
  settings: Record<string, unknown>;
};
export type Result = {
  attemptId: string;
  isCorrect: boolean;
  score: number;
  response?: Answer;
  correctResponse?: Answer;
  feedback: {
    analysis: string;
    analysisBlocks?: {
      type: string;
      text?: string;
      url?: string;
      caption?: string;
    }[];
    takeaway: string;
  };
};
export type RunSession = {
  authenticated: boolean;
  guest?: boolean;
  returnUrl?: string;
  title: string;
  questions?: Question[];
  answers?: Record<string, Result>;
};
export type Trigger = {
  kind: "before_course" | "after_segment" | "at_time";
  segmentId?: string;
  time?: number;
};
export type CheckpointConfig = {
  requireLogin?: boolean;
  key: string;
  title: string;
  trigger: Trigger;
  questionIds: string[];
  questions: { id: string; title: string }[];
};
export type CourseConfig = {
  courseKey: string;
  title: string;
  revision: number;
  segments: { id: string; title: string; duration: number }[];
  checkpoints: CheckpointConfig[];
};
